import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import AcademiaButton from '../../CommonComps/Buttons/AcademiaButton';
import CreateEditBillingInfoModal from '../../CommonComps/Modals/CreateEditBillingInfoModal';

const CreateBillAction = () => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);

  // rendering create bill action component here
  return (
    <div>
      <AcademiaButton
        type='button'
        onClick={() => setShowModal(true)}
        variant='info'
        icon={<TbSquareRoundedPlusFilled className='size-6' />}
      >
        Create Bill
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <CreateEditBillingInfoModal
            title='create'
            handleModalClose={() => setShowModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreateBillAction;
